import { d as debounce } from './debounce-CFN_LA0O.js';
import { C as Cart } from './cart-BEbKDMPu.js';
import { P as PubSub } from './pubsub-CoPYzvVm.js';
import { N as Notyf } from './notyf-DIw0RvBj.js';
import './uniq-BDEfcc0N.js';

class CartItem extends HTMLElement {
  #unsubscriber;
  #lineItemIndex = this.dataset.lineItemIndex;
  #removeButton;
  #loadingOverlay;

  connectedCallback() {
    this.#removeButton = this.querySelector('[data-line-item-remove]');
    this.#loadingOverlay = this.querySelector('.loading-overlay');

    this.#removeButton?.addEventListener('click', (event) => this.#handleRemove(event));
    this.#unsubscriber = PubSub.subscribe('quantity:change', ({ line, quantity }) =>
      this.#handleQuantityChange(line, quantity)
    );
  }

  disconnectedCallback() {
    this.#unsubscriber();
  }

  /**
   * @description Handle the remove button click event
   * @param {Event} event - The event object
   */
  async #handleRemove(event) {
    event.preventDefault();

    this.#handleLoading(true);

    try {
      await Cart.change({
        line: this.#lineItemIndex,
        quantity: 0,
      });
    } catch (error) {
      Notyf.error(error.message);
    } finally {
      this.#handleLoading(false);
    }
  }

  /**
   * @description Handle the quantity change event
   * @param {number} line - The line item index
   * @param {number} quantity - The quantity
   */
  #handleQuantityChange = debounce(async (line, quantity) => {
    if (line !== this.#lineItemIndex) return;

    this.#handleLoading(true);

    try {
      await Cart.change({
        line: this.#lineItemIndex,
        quantity,
      });
    } catch (error) {
      Notyf.error(error.message);
    } finally {
      this.#handleLoading(false);
    }
  }, 300);

  /**
   * @description Handle the loading overlay
   * @param {boolean} loading - The loading state
   */
  #handleLoading(loading) {
    if (!this.#loadingOverlay) return;
    this.#loadingOverlay.ariaHidden = !loading;
  }
}

customElements.define('line-item', CartItem);
